import type { AddressTagFilterTexts } from 'application/components/AddressTagFilter/types';

export const TEXTS = {
  PAGE_TITLE: 'Видеоволны',
  CREATE_VIDEO_STREAM: 'Создать видеоволну',
  MB: 'Мб',
  SIZE_LESS_THAN_MB: '< 1 Мб',
  FILE_FORMS: ['файл', 'файла', 'файлов'],
  SETTINGS: 'Настройки',
  POINTS: 'Адреса',
  POINTS_LIST_EMPTY: 'У вас нет адресов, поддерживающих видео вещание',
  POINTS_LIST_FILTERED_EMPTY: 'По вашему запросу адресов не найдено',
  MODAL_BIND_DISABLED_POINT_HINT_TEXT: 'Видеоволна уже запущена по выбранному адресу',
  VIDEO_STREAM_TURNED_OFF: 'Видеоволна пока нигде не включена',
  SAVE: 'Сохранить',
  VIDEO_STREAM_SAVE_ERROR: 'Не удалось сохранить видеоволну',
  VIDEO_STREAM_REFRESH_ERROR: 'Видеоволна сохранена, но не удалось обновить данные. Повторите обновление',
  RETRY_VIDEO_STREAM_REFRESH: 'Повторить обновление',
  START_STREAM: 'Запустить видеоволну',
  VIDEO_STREAM_POINTS_SAVE_SUCCESS_TEXT: 'Адреса видеоволны успешно сохранены',
  MODAL_BIND_SUCCESS_BUTTON_CANCEL_TEXT: 'Вернуться к видеоволнам',
  MODAL_BIND_SUCCESS_TO_POINTS_TEXT: 'Перейти к адресам',
  MODAL_BIND_SUCCESS_TITLE: 'Видеоволна запущена!',
  MODAL_BIND_WITHOUT_PLAYING_SUCCESS_TITLE: 'Видеоволна привязана!',
  MODAL_BIND_SUCCESS_SELECTED_POINTS_TEXT:
    'Видеоволна запустится после загрузки. Статус можно посмотреть в меню на вашем устройстве',
  MODAL_BIND_WITHOUT_PLAYING_SUCCESS_SELECTED_POINTS_TEXT:
    'Для запуска видеоволны на выбранных адресах привяжите тип плеера, который поддерживает воспроизведение видео',
  SEARCH: 'Поиск по адресам',
  VIDEO_STREAM_INFO_TITLE: 'Медиафайлы',
  VIDEO_STREAM_INFO_NO_POINTS: 'Медиафайлы загружаются. Воспроизведение скоро начнется',
  STREAM_INFO_CHANGE: 'Изменить',
  CREATE_VIDEO_STREAM_MODAL_TITLE: 'Создание видеоволны',
  CREATE_VIDEO_STREAM_MODAL_SELECT_BUTTON: 'Выбрать',
  CREATE_VIDEO_STREAM_MODAL_BUTTON_UPLOAD: 'Загрузить файл до 500Мб',
  CREATE_VIDEO_STREAM_INPUT_PLACEHOLDER: 'Поиск',
  CREATE_VIDEO_STREAM_FORMATS: 'Форматы файлов: .mp4, .jpg, .png',
  CREATE_VIDEO_STREAM_SELECT_FILES: 'Или выберите из загруженных файлов:',
  CREATE_VIDEO_STREAM_EMPTY_FILES: 'Нет загруженных файлов',
  UPLOADING: 'Загружается...',
  UPLOAD_ERROR: 'Ошибка загрузки',
  UPLOAD_REFRESH_ERROR: 'Файл загружен, но не удалось обновить список',
  RETRY_UPLOAD: 'Повторить загрузку',
  RETRY_LIBRARY_REFRESH: 'Повторить обновление списка',
  REMOVE_UPLOAD: 'Удалить из списка',
  SELECT_MEDIAFILE: (title: string) => `Выбрать файл: ${title}`,
  INVALID_UPLOAD_FILE: 'Поддерживаются файлы .mp4, .jpg, .png размером до 500Мб',
  SEARCH_PLACEHOLDER: 'Поиск по адресам',

  CREATE_VIDEO_STREAM_TITLE: 'Создание видеоволны',
  EDIT_VIDEO_STREAM_TITLE: 'Изменение видеоволны',

  EDIT_VIDEO_STREAM_TITLE_LABEL: 'Название видеоволны',

  EDIT_VIDEO_STREAM_DESCRIPTION_PLACEHOLDER: 'Краткая информация о медиафайлах в этой видеоволне',
  EDIT_VIDEO_STREAM_DESCRIPTION_LABEL: 'Описание',

  ADD_FILE: 'Добавить файл',

  NEXT: 'Далее',
  MODAL_BIND_TITLE: 'Запуск видеоволны',
  MODAL_BIND_NO_ADDRESS: 'У вас пока нет активных адресов для запуска видеоволны',
  MODAL_VIDEO_REQUEST_SUCCESS_TEXT: 'Запрос отправлен. Менеджер свяжется с вами в ближайшее время',
  IMAGE_HELP_TEXT: 'Мин.значение 00:00:01',
  MEDIAFILE_DURATION: 'Длительность',
  MEDIAFILE_DURATION_HELP: 'Мин. 00:00:01',
  VIDEO_HELP_TEXT: 'Повторять (количество раз)',
  IMAGE_MOBILE_HELP_TEXT: 'Мин. знач. 00:00:01',
  VIDEO_MOBILE_HELP_TEXT: 'Повторять (кол-во раз)',
  REPEATS_COUNT: 'Кол-во повторов: ',
  DUPLICATE: 'Дублировать',
  REMOVE_FROM_VIDEO_STREAM: 'Удалить из видеоволны',
  TIME_PLACEHOLDER: '00:00:00',
  TIME_MASK: 'час:мин:сек',

  VIDEO_STREAMS_EMPTY: 'Упс... видеоволны не найдены',
  PREVIEW: 'Превью',
  VIDEO_STREAM_PREVIEW: 'Превью видеоволны',
  VIDEO_STREAM_COPY: 'Копировать видеоволну',
  VIDEO_STREAM_COPY_SUCCESS: 'Создана копия видеоволны',
  FINED_IN_VIDEO_STREAMS: 'Найдено по видеоволнам',
  LINKED_TAGS_MODAL_TEXT: 'Отмечайте тегами названия, ответственного или город, чтобы быстро фильтровать видеоволны',

  BLOCK_EDIT_WARNING:
    'Редактирование недоступно, поскольку видео поток добавлен в группу устройств и не является мастер потоком',
  GROUPS: 'Группы',
  MENU_EDITOR_BUTTON: 'Редактор меню',
  EMENU_PREVIEW_UNAVAILABLE: 'Превью E-menu недоступно в превью видеоволны',
};

export const VIDEO_STREAM_TAG_FILTER_TEXTS: AddressTagFilterTexts = {
  filterButtonLabel: 'Фильтр по тегам адресов',
  mainSearchPlaceholder: TEXTS.SEARCH_PLACEHOLDER,
  tagSearchPlaceholder: 'Поиск тегов',
  exactSearch: 'Точный поиск',
  exactSearchInfoLabel: 'Как работает точный поиск',
  exactSearchTooltip:
    'Если точный поиск включен — показываются результаты со всеми выбранными тегами.\nЕсли выключен — показываются результаты, содержащие любой из выбранных тегов.',
  clearTags: 'Очистить',
  moreTags: (hiddenCount: number) => `Еще ${hiddenCount}`,
  hideTags: 'Свернуть',
  removeTag: (tagTitle: string) => `Удалить тег ${tagTitle}`,
  showAllTags: 'Показать все выбранные теги адресов',
};
